const Metadata = {
  version: '1.7.53',
  country_calling_codes: { '46': ['SE'] },
  countries: {
    SE: [
      '46',
      '00',
      '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
      [6, 7, 8, 9, 10],
      [
        ['(\\d{2})(\\d{2,3})(\\d{2})', '$1-$2 $3', ['20'], '0$1', 0, '$1 $2 $3'],
        ['(\\d{3})(\\d{4})', '$1-$2', ['9(?:00|39|44)'], '0$1', 0, '$1 $2'],
        [
          '(\\d{2})(\\d{3})(\\d{2})',
          '$1-$2 $3',
          ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
          '0$1',
          0,
          '$1 $2 $3',
        ],
        ['(\\d)(\\d{2,3})(\\d{2})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
        [
          '(\\d{3})(\\d{2,3})(\\d{2})',
          '$1-$2 $3',
          [
            '1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])',
          ],
          '0$1',
          0,
          '$1 $2 $3',
        ],
        ['(\\d{3})(\\d{2,3})(\\d{3})', '$1-$2 $3', ['9(?:00|39|44)'], '0$1', 0, '$1 $2 $3'],
        [
          '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
          '$1-$2 $3 $4',
          ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
          '0$1',
          0,
          '$1 $2 $3 $4',
        ],
        ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1-$2 $3 $4', ['10|7'], '0$1', 0, '$1 $2 $3 $4'],
        ['(\\d)(\\d{3})(\\d{3})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
        [
          '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
          '$1-$2 $3 $4',
          ['[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
          '0$1',
          0,
          '$1 $2 $3 $4',
        ],
        ['(\\d{3})(\\d{2})(\\d{2})(\\d{3})', '$1-$2 $3 $4', ['9'], '0$1', 0, '$1 $2 $3 $4'],
        [
          '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
          '$1-$2 $3 $4 $5',
          ['[26]'],
          '0$1',
          0,
          '$1 $2 $3 $4 $5',
        ],
      ],
      '0',
      0,
      0,
      0,
      0,
      0,
      [
        [
          '(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}',
          [7, 8, 9],
        ],
        ['7[02369]\\d{7}', [9]],
        ['20\\d{4,7}', [6, 7, 8, 9]],
        ['649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}', [7, 8, 9, 10]],
        ['75[1-8]\\d{6}', [9]],
        0,
        ['10[1-8]\\d{6}', [9]],
        ['74[02-9]\\d{6}', [9]],
        0,
        ['77[0-7]\\d{6}', [9]],
      ],
    ],
  },
  nonGeographic: {},
};

export default Metadata;
